/* eslint-disable no-underscore-dangle */
import type { Nullable } from 'corgi-types';
import { Cookie as CookieEnum } from 'corgi-types';
import type { CookieSetOptions } from 'universal-cookie';
import Cookie from 'universal-cookie';

export class CookieStorage {
  static normalizeNumber(value) {
    value = Number(value);

    return isNaN(value) ? 0 : Math.max(0, value);
  }

  static normalizeString(value) {
    return typeof value === 'string' ? value : '';
  }

  private cookie: Cookie | null;

  /**
   * Creates an instance of universal cookie storage.
   *
   * @constructor
   */
  constructor() {
    this.cookie = null;
    this.init();
  }

  init() {
    this.cookie = new Cookie();
  }

  __get(key) {
    return this.cookie.get(key);
  }

  __set(key, value, options: CookieSetOptions) {
    return this.cookie.set(key, value, options);
  }

  getWishlistCount() {
    return CookieStorage.normalizeNumber(this.__get(CookieEnum.WishlistItemsCount));
  }

  setWishlistCount(count: number, options = {}) {
    this.__set(CookieEnum.WishlistItemsCount, CookieStorage.normalizeNumber(count), options);
  }

  getCartCount() {
    return CookieStorage.normalizeNumber(this.__get(CookieEnum.CartItemsCount));
  }

  getZipCode() {
    return this.__get(CookieEnum.ZipCode) ?? null;
  }

  setZipCode(zipCode: Nullable<string>) {
    if (zipCode) {
      const MAX_AGE = 365 * 24 * 60 * 60;
      this.__set(CookieEnum.ZipCode, zipCode, { path: '/', maxAge: MAX_AGE, secure: true });
    }
  }
}

export default new CookieStorage();
